import { router } from '../router/Router';
import * as Network from './network';
import { createI18n } from './core/i18nCore';

export const i18n = createI18n({
    httpClient: Network,
    urlPrefix: () => router.appPrefix,
    getAppIdFallback: () => (window.k2api && window.k2api.applicationId) || 'default',
});
